export const keywords = [
  'Kumbh Mela Accommodation',
  'Kumbh Mela',
  'kumbh',
  'kumbh mela',
  'magh mela 2026',
  'kumbh accommodation',
  'prayag raj',
  'campsite',
  'kumbh camp',
  'kumbh sukrit',
];
